import React, { FC } from "react";
import { useField } from "react-final-form";
import { useDispatch } from "react-redux";
import { changeSelectedRoute } from "../../../redux/navmode.action";
import { colors, generateRouteName } from "../tools";
import { Button } from "react-admin";

interface AddRouteButtonProps {
  setIsOpenDetailRoute: any;
}

const AddRouteButton: FC<AddRouteButtonProps> = ({ setIsOpenDetailRoute }) => {
  const dispatch = useDispatch();
  const routesField = useField("routes");
  const schoolField = useField("school");
  const busScheduleField = useField("busSchedule");

  const handleOpenNewRoute = () => {
    const routeName = generateRouteName(
      busScheduleField.input.value.type,
      routesField.input.value.length + 1,
    );

    const initialRoute: any = {
      id: routesField.input.value.length + 1,
      realRouteId: 0,
      routeName: routeName,
      startTime: "",
      endTime: "",
      driverId: null,
      busAssistantId: null,
      vehicleId: null,
      backupDriverIds: [],
      backupBusAssistantIds: [],
      backupVehicleIds: [],
      assignedSubcontractor: null,
      routeColor: colors[routesField.input.value.length % colors.length], // if colors are not enough, roll over the colors array to first index
      routeGeometries: [],
      routeLocations: [
        {
          lat: schoolField.input.value.lat,
          lng: schoolField.input.value.lng,
          street: schoolField.input.value.street,
          unitNumber: schoolField.input.value.unitNumber,
          blockNumber: schoolField.input.value.blockNumber,
          building: schoolField.input.value.building,
          address: schoolField.input.value.address,
          postalCode: schoolField.input.value.postalCode,
          order: 1,
          arrivalTime: "",
          students: [],
        },
      ],
    };

    setIsOpenDetailRoute(true);

    dispatch(changeSelectedRoute(initialRoute));
  };

  return <Button label="Add Route" onClick={handleOpenNewRoute} />;
};

export default AddRouteButton;
